import { BuilderComponentGroup } from '../types'
import { BasicLayoutDesignBlocks } from './basic-layouts'
import { ButtonsDesignBlocks } from './buttons'
import { ComplexLayoutDesignBlocks } from './complex-layouts'
import { ContactUsDesignBlocks } from './contact-us'
import { CTA } from './cta'
import { DashboardsDesignBlocks } from './dashboards'
import { HeroDesignBlocks } from './hero'
import { PageDashboard } from './page-dashboard'
import { ProfileDesignBlocks } from './profile'
import { ServiceDesignBlocks } from './service'
import { TeamDesignBlocks } from './team'

export const DEFAULT_DESIGN_BLOCKS_GROUPS: BuilderComponentGroup[] = [
  BasicLayoutDesignBlocks,
  ComplexLayoutDesignBlocks,
  HeroDesignBlocks,
  CTA,
  ProfileDesignBlocks,
  ContactUsDesignBlocks,
  TeamDesignBlocks,
  ButtonsDesignBlocks,
  DashboardsDesignBlocks,
  ServiceDesignBlocks,
]

export const DEFAULT_PAGE_GROUPS: BuilderComponentGroup[] = [PageDashboard]
